var styleDataHash = 'bad98907';  
export const injectCss = (() => {
  var css = `.YFo2H{align-items:center;background:transparent;border:none;cursor:pointer;display:flex;min-height:48px;padding:0;position:relative;width:max-content}.YFo2H:hover{opacity:.5}.VoK-n{display:flex;padding-inline-start:10px}.VoK-n,.VoK-n svg{color:var(--ricos-action-color,#116dff)}.VoK-n svg{fill:var(--ricos-action-color,#116dff)}.bja52{cursor:pointer;font-size:16px;font-stretch:normal;font-style:normal;font-weight:400;letter-spacing:normal;padding-inline-start:8px}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});

injectCss();



export default {
  "new_pair_container": "YFo2H",
  "new_pair_button": "VoK-n",
  "new_pair_label": "bja52"
};